module.exports = __webpack_public_path__ + "media/src/assets/images/property_photo5-1ed6aa632cbe0f6dc815f61997beef06.jpg";